const Filters = {
  install (Vue) {
    Vue.filter('createdAt2date', unixTimestamp => {
      if (!unixTimestamp) return ''
      return new Date(unixTimestamp).toLocaleDateString('de-AT')
    })

    Vue.filter('createdAt2time', unixTimestamp => {
      if (!unixTimestamp) return ''
      let time = new Date(unixTimestamp).toLocaleTimeString('de-AT')
      time = time.toString().slice(0, 5)
      return time
    })

    Vue.filter('createdAt2timeWithSeconds', unixTimestamp => {
      if (!unixTimestamp) return ''
      let time = new Date(unixTimestamp).toLocaleTimeString('de-AT')
      time = time.toString().slice(0, 8)
      return time
    })

    Vue.filter('readableDateTime', unixTimestamp => {
      if (!unixTimestamp) return ''

      const date = new Date(unixTimestamp) // .toLocaleDateString('en-US')

      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + (date.getDay() + 1)).slice(-2)

      const hour = ('0' + date.getHours()).slice(-2)
      const min = ('0' + date.getMinutes()).slice(-2)
      const sec = ('0' + date.getSeconds()).slice(-2)

      const readableDateTime = year + '-' + month + '-' + day + '_' + hour + min + sec

      return readableDateTime
    })

    Vue.filter('seconds2hms', seconds => {
      if (!seconds) return ''

      // @src https://stackoverflow.com/questions/1322732/convert-seconds-to-hh-mm-ss-with-javascript
      function hms (seconds) {
        return [3600, 60]
          .reduceRight(
            (p, b) => r => [Math.floor(r / b)].concat(p(r % b)),
            r => [r]
          )(seconds)
          .map(a => a.toString().padStart(2, '0'))
          .join(':')
      }

      return hms(seconds)
    })
  }
}

export default Filters

// Automatic installation if Vue has been added to the global scope.
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(Filters)
// }
